import 'styles/components/generic/typeahead.less'
import TypeAheadInput, { SuggestionSource, TypeAheadInputOpts } from './TypeAheadInput'
import { get, post } from '../../tools/request'
import { Variable } from 'alkali'

interface TermInputOpts extends TypeAheadInputOpts<string> {
	termType?: string
}

interface Term {
	sense: string
	label: string
	alts: string[]
}

class TermSuggestionSource implements SuggestionSource<Term> {
	constructor(private readonly type: string) {}
	itemToText(item: Term) {
		return item.label
	}
	itemToEntry({ label, definition}: Term) {
		return { label, title: definition || label }
	}
	private lookupTerm(label: string): Promise<any> {
		return ((label || '').length == 0) ? Promise.resolve(null) :
			post('/portal/term/bystring/search', {
				data: {
					query: label,
					type: this.type
				}
			}).catch(() => null)
	}
	findExact(value: string): Promise<Term> {
		return this.lookupTerm(value)
		//return Promise.resolve()
	}
	private retrieveSuggestions(query: string): Promise<any> {
		return get<any>('/portal/Suggestions', {
			data: {
				search: query,
				type: this.type
			}
		})
	}
	findMatches(query: string): Promise<Term[]> {
		return this.retrieveSuggestions(query).then((results = []) =>
			results.map(suggestion => ({
				...suggestion,
				sense: suggestion.id,
				alts: [suggestion.label]
			}))
		)
	}
}

export default class TermInput extends TypeAheadInput.with('.form-control', { placeholder: 'Term' }) {
	created(properties: TermInputOpts) {
		// caller should pass units as property
		properties.source = new TermSuggestionSource(properties.termType)
		properties.valueVar || (properties.valueVar = new Variable())
		if (!properties.title) {
			properties.title = properties.valueVar.to(item =>
				item ? `${properties.source.itemToText(item)} (${item.sense})` : `"${properties.content.valueOf()}"`
			)
		}
		super.created(properties)
	}
}